import { Tooltip } from '@servicetitan/design-system';
import { StyledButton } from './LinkoutButton.styled';

type Props = {
  id?: string;
  tooltipText: string;
  onClick: () => void;
};

const LinkoutButton = ({ id, tooltipText, onClick }: Props) => {
  return (
    <Tooltip el='div' text={tooltipText} portal>
      <StyledButton
        aria-label={tooltipText}
        id={id}
        fill='subtle'
        color='primary'
        size='xsmall'
        iconName='open_in_new'
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default LinkoutButton;
